import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from '../../utils/withRouter';
import Loader from '../../utils/Loader'
import { toastError, toastSuccess, downloadReport } from '../../utils/constants'
// import Header from '../../common_components/Header';
import { get_order_confirmation_action, download_performa_invoice_action, get_payment_details_for_email_action, get_payment_details_for_download_action } from '../../actions/bookingDetails_action/orderConfirmation_action';
import "react-datepicker/dist/react-datepicker.css";
import 'owl.carousel/dist/assets/owl.carousel.css';
import Header from '../../common_components/Header';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import moment from 'moment';
const style = `
.thankYou_page {
    width: 46%;
    margin: 7rem auto 1rem;
    background-color: transparent;
  }
  .thankYou_page .head_text i{
    font-size: 35px;
    margin-bottom: 15px;
    color: #1ac61a;
  }
  .thankYou_page .head_text .text_title{
    margin-bottom: 30px;
    color: #000;
    font-size: 18px;
    font-weight: 600;
  }
  .thankYou_page .head_text p{
    font-size: 12px;
    margin-bottom: 3px;
    font-weight: 600;
    color: #797979;
  }
  .thankYou_page .head_text p:last-child{
    margin-bottom: 20px;
    color: #a19e9e;
  }
  .thankYou_page_content{
    height: auto;
    border-radius: 5px;
    text-align: left;
    color: #918e8e;
  }
  .thankYou_page_content .card{
    margin-bottom: 0.7rem;
  }
  .thankYou_page_content h6.head_text{
    color: #f0201e;
    font-size: 14px;
    margin-bottom: 3px;
  }
  .thankYou_page_content .Address_para{
    color: #878a99;
    font-size: 12px;
    margin-bottom: 0px;
  }
  .thankYou_page_content .card-header{
    background: white;
    border-bottom: 0px;
    padding: 0.75rem 1rem 0;
  }

  .thankYou_page_content .card-body{
    padding: 1rem 1rem;
  }
  .thankYou_page_content .card-body .add_service_para{
    border-top: 1px dashed #e9e9e9;
    padding: 8px 0px 0px;
    margin: 10px 0px 0;
  }
  .thankYou_page_content .total_card_count{
    background: #f3f6f9;
  }
  .total_card_count .total_div{
    justify-content: space-between;
  }
  .total_card_count .total_div .total_text{
    color: #4d4643 !important;
    font-weight: 500;
    font-family: Poppins,sans-serif;
    font-size: 14px;
  }
  .total_card_count .total_div .total_count_text{
      font-family: Poppins,sans-serif;
      font-size: 18px;
  }
  .bg_grey{
    background: #bbbbbb !important;
  }
  .add_service_para:before{
    display: none;
  }
.order_no_and_date {
  background: #dde9ff;
  border: 1px solid #a8bee7;
  border-radius: 2px;
  padding: 10px 10px;
  margin-bottom: 10px;
  color: #22a3d7;
}
.order_no_and_date p{
  margin-bottom: 0;
}
.my_color{
  color:#918e8e !important;
}
  `
class OrderConfirmed extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            uniqueNo: '',
            userId: '',
            grandTotal: '',
            finalCurrency: '',
            orderList: [],
            isClickValidation: false
        }
        this.getOrderConfirmationDetails = this.getOrderConfirmationDetails.bind(this)
        this.createOrderConfirmationList = this.createOrderConfirmationList.bind(this)
        this.downlaodPerformaInvoice = this.downlaodPerformaInvoice.bind(this)
        this.onOrderHistory = this.onOrderHistory.bind(this)
        this.sendEmail = this.sendEmail.bind(this)

    }

    componentDidMount() {
        if (JSON.parse(sessionStorage.getItem('UserLoginData')) == null) {
            console.log('log')
            setTimeout(() => {
                this.props.navigate('/login')
            }, 500);
        }
        console.log(JSON.parse(sessionStorage.getItem('UserLoginData')))
        sessionStorage.removeItem('bookArray')
        sessionStorage.removeItem('validationDateList')
        console.log(this.props)
        this.setState({
            uniqueNo: this.props.params != null && this.props.params.id != null ? this.props.params.id : '',
            userId: sessionStorage.getItem('userId') == '' || sessionStorage.getItem('userId') == null ? '' : sessionStorage.getItem('userId')
        })

        setTimeout(() => {
            console.log(window.location)
            this.getOrderConfirmationDetails()
            console.log(this.props.params)
        }, 200);
    }

    getOrderConfirmationDetails() {
        const { userId, uniqueNo } = this.state
        this.setState({ isLoading: true })

        this.props.get_order_confirmation_action((userId == '' || userId == null) ? null : userId, (uniqueNo == '' || uniqueNo == null) ? null : uniqueNo)
            .then((data) => {
                console.log(data)
                if (data.error != 1) {
                    setTimeout(() => {
                        this.createOrderConfirmationList(data.data)
                        this.setState({ isLoading: false })
                    }, 300)
                }
                else {

                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }


    createOrderConfirmationList(data) {
        const { orderList } = this.state
        var orderIDList = []
        var finalList = []
        console.log(data)

        //create final list
        for (var i = 0; i < data.orderArr.length; i++) {
            var summaryArr = []
            var additionalServicesArr = []
            var objectID = {}
            if (!orderIDList.includes(data.orderArr[i].OrderID)) {
                var ID = data.orderArr[i].OrderID
                orderIDList.push(data.orderArr[i].OrderID)
                for (var j = 0; j < data.orderArr.length; j++) {
                    if (ID == data.orderArr[j].OrderID) {
                        summaryArr.push(data.orderArr[j])
                        objectID.centerName = data.orderArr[j].CenterName
                        objectID.centerAdd = data.orderArr[j].ADDRESS
                        objectID.orderNo = data.orderArr[j].OrderNo
                        objectID.orderStatus = data.orderArr[j].OrderStatus
                        objectID.paymentStatus = data.orderArr[j].PaymentStatus
                        objectID.currency = data.orderArr[j].Currency
                        objectID.orderDate = moment(data.orderArr[j].OrderDate).format('MMMM Do YYYY')
                        // var tempPerformaNo = data.orderArr[j].ProformaInvoice_No
                        // for (var a = 0; a < data.orderArr[j].ProformaInvoice_No.length; a++) {
                        //     if (tempPerformaNo.includes('/')) {
                        //         tempPerformaNo = tempPerformaNo.replace('/', '_')
                        //     }
                        // }
                        // console.log(tempPerformaNo)
                        // objectID.performaInvoiceNo = tempPerformaNo
                    }
                }
                for (var j = 0; j < data.AdditionalSerivcesArr.length; j++) {
                    if (data.AdditionalSerivcesArr[j].Services != null) {
                        if (ID == data.AdditionalSerivcesArr[j].OrderID && data.AdditionalSerivcesArr[j].AdditionalServicesPaid == 1) {
                            additionalServicesArr.push(data.AdditionalSerivcesArr[j])
                        }
                    }
                }
                for (var j = 0; j < data.PriceArr.length; j++) {
                    if (ID == data.PriceArr[j].OrderID) {
                        objectID.Price = data.PriceArr[j]
                    }
                }
                for (var j = 0; j < data.AdditionalSerivcesPriceArr.length; j++) {
                    if (ID == data.AdditionalSerivcesPriceArr[j].OrderID) {
                        objectID.AdditionalServicePrice = data.AdditionalSerivcesPriceArr[j]
                    }
                }

                objectID.OrderID = data.orderArr[i].OrderID
                objectID.summary = summaryArr
                objectID.additionalServices = additionalServicesArr
                finalList.push(objectID)
            }
        }
        console.log(finalList)
        this.setState({ orderList: finalList })

        var currencyArr = []
        var GT = 0
        for (var i = 0; i < finalList.length; i++) {
            console.log(finalList[i].Price.NetAmount)
            if (finalList[i].Price != undefined) {
                GT = GT + finalList[i].Price.Total
            }
            if (finalList[i].AdditionalServicePrice != undefined) {
                GT = GT + finalList[i].AdditionalServicePrice.Total
            }
            console.log("here", finalList[i].AdditionalServicePrice)
            if (!currencyArr.includes(finalList[i].currency)) {
                currencyArr.push(finalList[i].currency)
            }
        }

        if (currencyArr.length == 1) {
            this.setState({ finalCurrency: currencyArr[0] })
        }
        this.setState({ grandTotal: GT })
        console.log(GT)
    }

    onOrderHistory(e) {
        // const { } = this.state
        const { isClickValidation } = this.state
        e.preventDefault();
        this.setState({ isClickValidation: true }, () => {
            this.props.navigate('/my_orders')
        })
    }

    downlaodPerformaInvoice(orderID, performaInvoiceNo) {
        const { userId } = this.state
        this.setState({ isLoading: true })

        this.props.get_payment_details_for_download_action(userId, orderID)
            .then((data) => {
                console.log(data)
                if (data.error != 1) {
                    if (data.data.length > 0) {
                        var performaInvoiceID = data.data[0].ProformaInvoiceID
                        var ReceiptID = data.data[0].ReceiptID
                        var ReceiptNo = data.data[0].ReceiptNo
                        for (var a = 0; a < data.data[0].ReceiptNo.length; a++) {
                            if (ReceiptNo.includes('/')) {
                                ReceiptNo = ReceiptNo.replace('/', '_')
                            }
                        }
                        console.log(ReceiptNo)

                        this.props.download_performa_invoice_action(userId, ReceiptID, ReceiptNo)
                            .then((data) => {
                                if (data.error != 1) {
                                    this.setState({ isLoading: false })
                                    console.log(data)
                                    var url = `${downloadReport}?SessionIdentifier=${data}&Export=true`;
                                    const win = window.location.replace(url, '_blank');
                                    if (win != null) {
                                        win.focus();
                                    }
                                }
                                else {

                                    this.setState({ isLoading: false })
                                    toastError(data.msg)
                                }
                            })
                            .catch((err) => {
                                console.log(err)
                            })
                        setTimeout(() => {
                            this.setState({ isLoading: false })
                        }, 300)
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError("cannot download")
                    }
                }
                else {

                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    sendEmail(orderID) {
        const { userId } = this.state
        this.setState({ isLoading: true })

        this.props.get_payment_details_for_email_action(userId, orderID)
            .then((data) => {
                console.log(data)
                if (data.error != 1) {
                    setTimeout(() => {
                        this.setState({ isLoading: false })
                        toastSuccess("Email sent successfully")
                    }, 300)
                }
                else {

                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })

    }

    componentWillUnmount() {
        const { isClickValidation } = this.state
        if (!isClickValidation) {
            sessionStorage.clear()
            console.log("unmout")
            window.location.replace('http://localhost:3000/#/');
        }
    }

    render() {
        const { isLoading, finalCurrency, grandTotal, orderList } = this.state

        return (

            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <main id="main">
                    <Header data={[2]} />
                    <div class="thankYou_page">
                        <div class="row head_text">
                            <div class="col-md-12 text-center">
                                <i class="fa fa-check-circle"></i>
                                <h6 class="text_title">Booking Confirmed!</h6>
                            </div>
                        </div>

                        <div class="thankYou_page_content">
                            {orderList.length > 0 && orderList.map((data) => (
                                <div class="card product">
                                    <div class="card-header">
                                        <div class="order_no_and_date">
                                            <p>Order No : {data.orderNo}</p>
                                            <p>Order Date : {data.orderDate}</p>
                                        </div>

                                        <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: "space-between" }}>
                                            <div>
                                                <h5 class="text-truncate head_text"><a class="text-dark">{data.centerName}</a></h5>
                                                <p class="text-muted Address_para"><i class="fa fa-map-marker"></i> {data.centerAdd}</p>
                                            </div>
                                            {/* <div>
                                                <a class="btn btn-success btn-sm fs-12" onClick={() => this.downlaodPerformaInvoice(data.OrderID, data.performaInvoiceNo)}><i class="fa fa-download"></i> Download</a>
                                                <button onClick={() => this.sendEmail(data.OrderID)} class="btn btn-warning btn-sm fs-12 ml-2">  <a><i class="fa fa-envelope"></i> Email</a></button>

                                            </div> */}
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <div class=" gy-3">
                                            <div class="slot_para">
                                                <h6>Rental Summary</h6>
                                                <div class="row mr_0">
                                                    <div class="col-md-4 padding_0">
                                                        <span><strong>Booking Date</strong></span>
                                                    </div>
                                                    <div class="col-md-3 padding_0">
                                                        <span><strong>Booking Slot</strong></span>
                                                    </div>
                                                    <div class="col-md-2 padding_0 text-center">
                                                        <span><strong>Selected Hrs</strong></span>
                                                    </div>
                                                    <div class="col-md-3 padding_0 text-right">
                                                        <span><strong>Amount</strong></span>
                                                    </div>
                                                </div>
                                                {data.summary.map((summ) => (
                                                    <div class="row mr_0">
                                                        <div class="col-md-4 padding_0">
                                                            <span>{moment(summ.BookingDate).format('MMMM Do YYYY')}</span>
                                                        </div>
                                                        <div class="col-md-3 padding_0">
                                                            <span>{summ.BookingSlot}</span>
                                                        </div>
                                                        <div class="col-md-2 padding_0 text-center">
                                                            <span>{summ.Selectedhrs}</span>
                                                        </div>
                                                        <div class="col-md-3 padding_0 text-right">
                                                            <span>{data.currency == 'INR' ? '₹' : '$'} {summ.GrossAmount.toLocaleString("en-IN")}</span>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>

                                        </div>
                                    </div>
                                    <div class="card-footer">
                                        <div class="align-items-center gy-3">
                                            <div class="">
                                                <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: "space-between" }}>
                                                    <div class="width_100 my_color">Price</div>
                                                    <h5 class="fs-14 mb-0 my_color">{data.currency == 'INR' ? '₹' : '$'} <span class="product-line-price">{(parseInt(data.Price.GrossAmount).toLocaleString("en-IN"))}</span></h5>
                                                </div>
                                                {data.Price.DiscountAmount != null && data.Price.DiscountAmount != 0 && <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: "space-between" }}>
                                                    <div class="width_100 my_color">Discount Amount</div>
                                                    <h5 class="fs-14 mb-0 text-danger">-{data.currency == 'INR' ? '₹' : '$'} <span class="product-line-price">{(parseInt(data.Price.DiscountAmount).toLocaleString("en-IN"))}</span></h5>
                                                </div>}
                                                <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: "space-between" }}>
                                                    <div class="width_100 my_color">(A) Net Amount</div>
                                                    <h5 class="fs-14 mb-0 my_color">{data.currency == 'INR' ? '₹' : '$'} <span class="product-line-price">{(parseInt(data.Price.NetAmount).toLocaleString("en-IN"))}</span></h5>
                                                </div>
                                                {data.Price.AdditionalHourCharges != null && data.Price.AdditionalHourCharges != 0 && <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: "space-between" }}>
                                                    <div class="width_100 my_color">Additional Hours charges</div>
                                                    <h5 class="fs-14 mb-0 my_color">{data.currency == 'INR' ? '₹' : '$'} <span class="product-line-price">{data.Price.AdditionalHourCharges != null ? (parseInt(data.Price.AdditionalHourCharges).toLocaleString("en-IN")) : 0}</span></h5>
                                                </div>}
                                                {data.Price.OvernightCharges != null && data.Price.OvernightCharges != 0 && <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: "space-between" }}>
                                                    <div class="width_100 my_color">Overnight charges</div>
                                                    <h5 class="fs-14 mb-0 my_color">{data.currency == 'INR' ? '₹' : '$'} <span class="product-line-price">{data.Price.OvernightCharges != null ? (parseInt(data.Price.OvernightCharges).toLocaleString("en-IN")) : 0}</span></h5>
                                                </div>}
                                                {data.Price.AdditionalDiscount != null && data.Price.AdditionalDiscount != 0 && <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: "space-between" }}>
                                                    <div class="width_100 my_color">Additional Discount </div>
                                                    <h5 class="fs-14 mb-0 text-danger">-{data.currency == 'INR' ? '₹' : '$'} <span class="product-line-price">{(parseInt(data.Price.AdditionalDiscount).toLocaleString("en-IN"))}</span></h5>
                                                </div>}
                                                {data.Price.AdditionalDiscount != null && data.Price.AdditionalDiscount != 0 && <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: "space-between" }}>
                                                    <div class="width_100 my_color">Additional Discount </div>
                                                    <h5 class="fs-14 mb-0 text-danger">-{data.currency == 'INR' ? '₹' : '$'} <span class="product-line-price">{(parseInt(data.Price.AdditionalDiscount).toLocaleString("en-IN"))}</span></h5>
                                                </div>}
                                                <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: "space-between" }}>
                                                    <div class="width_100 my_color">GST ( 18% )</div>
                                                    <h5 class="fs-14 mb-0 my_color">{data.currency == 'INR' ? '₹' : '$'} <span class="product-line-price">{(parseInt(data.Price.GST).toLocaleString("en-IN"))}</span></h5>
                                                </div>
                                                <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: "space-between" }}>
                                                    <div class="width_100 my_color">(B) Refundable Security Deposit</div>
                                                    <h5 class="fs-14 mb-0 my_color">{data.currency == 'INR' ? '₹' : '$'} <span class="product-line-price">{(parseInt(data.Price.SecurityDeposit).toLocaleString("en-IN"))} </span></h5>
                                                </div>
                                                <hr style={{ margin: '5px 0px', borderTop: "1px dashed rgba(0,0,0,.1)" }} />
                                                <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: "space-between" }}>
                                                    <div class="width_100 my_color"><b>Total</b></div>
                                                    <h5 class="fs-14 mb-0 my_color">{data.currency == 'INR' ? '₹' : '$'} <span class="product-line-price"><b>{(parseInt(data.Price.Total).toLocaleString("en-IN"))}</b></span></h5>
                                                </div>
                                                <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: "space-between" }}>
                                                    <div class="width_100 my_color"><b>Payment Received</b></div>
                                                    <h5 class="fs-14 mb-0 my_color">{data.currency == 'INR' ? '₹' : '$'} <span class="product-line-price"><b>{(parseFloat(data.Price.Paid).toLocaleString("en-IN"))}</b></span></h5>
                                                </div>
                                                <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: "space-between" }}>
                                                    <div class="width_100 my_color"><b>Balance</b></div>
                                                    <h5 class="fs-14 mb-0 my_color">{data.currency == 'INR' ? '₹' : '$'} <span class="product-line-price"><b>{(parseFloat(data.Price.OutStanding).toLocaleString("en-IN"))}</b></span></h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <div class=" gy-3">
                                            <div class="slot_para">
                                                {data.additionalServices.length > 0 &&
                                                    <div class="add_service_para">
                                                        <h6>Additional Services Summary</h6>
                                                        <div class="row mr_0">
                                                            <div class="col-md-4 padding_0">
                                                                <span><strong>Services</strong></span>
                                                            </div>
                                                            <div class="col-md-3 padding_0">
                                                                <span><strong>Type</strong></span>
                                                            </div>
                                                            <div class="col-md-2 padding_0 text-center">
                                                                <span><strong>Quantity</strong></span>
                                                            </div>
                                                            <div class="col-md-3 padding_0 text-right">
                                                                <span><strong>Amount (INR)</strong></span>
                                                            </div>
                                                        </div>
                                                        {data.additionalServices.map((add) => (
                                                            <div class="row mr_0">
                                                                <div class="col-md-4 padding_0">
                                                                    <span>{add.Services}</span>
                                                                </div>
                                                                <div class="col-md-3 padding_0">
                                                                    <span>{add.Type == 'S' ? 'Standard' : 'Premium'}</span>
                                                                </div>
                                                                <div class="col-md-2 padding_0 text-center">
                                                                    <span>{add.Quantity == 0 || add.Quantity == null || add.Quantity == '' ? '-' : add.Quantity}</span>
                                                                </div>
                                                                <div class="col-md-3 padding_0 text-right">
                                                                    <span>{data.currency == 'INR' ? '₹' : '$'} {add.GrossAmount.toLocaleString("en-IN")}</span>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    {data.AdditionalServicePrice != undefined &&
                                        <div class="card-footer">
                                            <div class="align-items-center gy-3">
                                                <div class="">
                                                    <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: "space-between" }}>
                                                        <div class="width_100 my_color">Price</div>
                                                        <h5 class="fs-14 mb-0 my_color">{data.currency == 'INR' ? '₹' : '$'} <span class="product-line-price">{(parseInt(data.AdditionalServicePrice.NetAmount).toLocaleString("en-IN"))}</span></h5>
                                                    </div>
                                                    <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: "space-between" }}>
                                                        <div class="width_100 my_color">GST ( 18% )</div>
                                                        <h5 class="fs-14 mb-0 my_color">{data.currency == 'INR' ? '₹' : '$'} <span class="product-line-price">{(parseInt(data.AdditionalServicePrice.GST).toLocaleString("en-IN"))}</span></h5>
                                                    </div>
                                                    <hr style={{ margin: '5px 0px', borderTop: "1px dashed rgba(0,0,0,.1)" }} />
                                                    <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: "space-between" }}>
                                                        <div class="width_100 my_color"><b>Total</b></div>
                                                        <h5 class="fs-14 mb-0 my_color">{data.currency == 'INR' ? '₹' : '$'} <span class="product-line-price"><b>{(parseInt(data.AdditionalServicePrice.Total).toLocaleString("en-IN"))}</b></span></h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <div class="card-footer">
                                        <div class="align-items-center gy-3">
                                            <div class="">
                                                <div class="d-flex align-items-center order_status_text">
                                                    <div class="width_100 ">Order Status : <span class="product-line-price fs-14">{data.orderStatus}</span></div>
                                                </div>
                                                <div class="d-flex align-items-center order_status_text">
                                                    <div class="width_100">Payment Status : <span class="product-line-price fs-14">{data.paymentStatus}</span></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}

                            <div class="total_card_count">
                                <div class="card">
                                    <div class="card-body bg_grey">
                                        <div class="d-flex total_div">
                                            <div class="total_text">Total : </div>
                                            <h5 class="fs-14 mb-0 ">{finalCurrency == 'INR' ? '₹' : '$'} <span class="product-line-price">{(parseInt(grandTotal).toLocaleString("en-IN"))}</span></h5>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12 text-center">
                                    <button class="btn btn-warning btn-sm" onClick={this.onOrderHistory}> <a>Order History</a></button>

                                </div>
                            </div>



                        </div>
                    </div>
                </main>
                <style type="text/css">
                    {style}
                </style>
            </>)
    }
}

export default withRouter(connect(null, { get_order_confirmation_action, download_performa_invoice_action, get_payment_details_for_email_action, get_payment_details_for_download_action })(OrderConfirmed));